import React from 'react';
import { useNavigate } from 'react-router-dom';
import Reels from '../reels/Reels';

// This component wraps the existing Reels component for the drawer route
const ReelsFeed = () => {
  return <Reels />;
};

export default ReelsFeed;

















